import { createSelector } from '@reduxjs/toolkit';

import type { ScheduleState } from '../types';

type SelectSlotInActiveDateByIdParams = {
  slotId: string;
};

const selectSlotInActiveDateById = createSelector(
  (state: ScheduleState) => state.schedule.activeDateKey,
  (state: ScheduleState) => state.schedule.dates,
  (_: ScheduleState, params: SelectSlotInActiveDateByIdParams) => params.slotId,
  (activeDateKey, dates, slotId) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!activeDateKey || !dates || !dates[activeDateKey]) return;
    return dates[activeDateKey].slots.find((slot) => slot.slotId === slotId);
  },
);

export { selectSlotInActiveDateById };
